export const exemptTaxExemptionReasons = [
  'Aviser',
  'Elektroniske nyhetstjenester',
  'Tidsskrift',
  'Bøker',
  'Andre publikasjoner',
  'Elektrisk kraft mv. til husholdningsbruk i Nord-Norge',
  'Kjøretøy mv.',
  'Fartøy mv.',
  'Luftfartøy mv.',
  'Plattformer, rørledninger mv.',
  'Oppføring av ambassadebygg',
  'Internasjonale militære styrker og kommandoenheter',
  'Overdragelse av virksomhet',
  'Biologisk materiale',
  'Begravelsestjenester',
  'Tilsvarende fritak som ved omsetning',
  'Bedriftskantiner mv.',
  'Veldedige formål mv.',
  'Primærnæringer',
];

export const zeroTaxExemptionReasons = [
  'Helsetjenester mv.',
  'Alternativ behandling',
  'Sosiale tjenester mv.',
  'Undervisningstjenester mv.',
  'Finansielle tjenester',
  'Kunst og kultur mv.',
  'Idrett mv.',
  'Offentlig myndighetsutøvelse mv.',
  'Tjenester innen staten',
  'Fast eiendom',
  'Veldedige og allmennyttige institusjoner og organisasjoner',
  'Ideelle organisasjoner og foreninger',
  'Lotteritjenester',
  'Seremonielle tjenester',
  'Tjenester som medlem av styre mv.',
  'Frimerker, sedler og mynter',
  'Varer brukt privat mv.',
  'Sletting av klimakvoter',
  // Not sure if this is legally right, but it is how the car mechanic services do it in practice.
  'Egenandel, forsikringsselskap',
];

import dayjs from '@/utils/dayjs';

type miniProductPrice = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validFrom: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validTo: any | null;
}

export const productPriceAt = <P extends miniProductPrice>(date: dayjs.Dayjs, product: {productPrices: P[]}): P | undefined => {
  return product
    .productPrices
    .find(price => date.isBetween(dayjs.strict(price.validFrom), dayjs.strict(price.validTo || '3000-01-01'), 'day', '[]'));
};
